export const HOME = '/';
export const BASIC = '/basic_usage';
export const VERTICAL_RESIZE = '/vertical_resize';
export const SET_BOUND = '/set_bound';
export const LAZY = '/lazy';
